<script>
import { swal } from "../../../helpers/handle_error.js";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
import DatePicker from "vue2-datepicker"; // add DatePicker
import { mapGetters } from "vuex";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      fields: [],
      not_receiving: false,
    };
  },
  validations: {
    fields: {
      $each: {
        grant_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
        received_date: { required },
        ammont: { required, minValue: minValue(1000), maxValue: maxValue(80000000) },
        beneficiary_id: { required },
        attachment_cash: {
          required,
          fileType: fileType("application/pdf"),
          fileSize: fileSize(1024 * 1024 * 2),
        },
      },
    },
    form: ["fields"],
  },
  methods: {
    ...mapGetters("beneficiaries", ["getBeneficiaries"]),
    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        grant_name: "",
        received_date: "",
        ammont: "",
        beneficiary_id: "",
        attachment_cash: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
      }
    },
    notReceiving(index) {
      this.fields.splice(index, 1);
      return this.not_receiving ? this.AddformDataS() : this.fields.splice(index, 1);
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات البدل النقدي</h5></div>

      <div class="col-md-12">
        <div class="form-check form-switch mb-3 ms-2 form-switch-md">
          <input
            @click="notReceiving(index)"
            class="form-check-input"
            type="checkbox"
            id="SwitchCheckSizemd"
            v-model="not_receiving"
          />
          <label class="form-check-label" for="SwitchCheckSizemd"
            >لم استلم بدل نقدي .</label
          >
        </div>
      </div>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label="الجهة المانحة : "
              label-for="grant_name"
            >
              <b-form-input
                id="grant_name"
                type="text"
                placeholder="ادخل الجهة المانحة"
                v-model.trim="field.grant_name.$model"
                :class="{ 'is-invalid': field.grant_name.$error }"
              ></b-form-input>
              <div v-if="field.grant_name.$error" class="invalid-feedback">
                <span v-if="!field.grant_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.grant_name.minLength"
                  >يجب أن تكون الجهة المانحة من حرفين على الأقل</span
                >
                <span v-if="!field.grant_name.maxLength"
                  >يجب أن تكون الجهة المانحة من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label="تاريخ الاستلام : "
              label-for="received_date"
            >
              <date-picker
                id="received_date"
                type="date"
                lang="ar"
                value-type="DD-MM-YYYY"
                format="DD-MM-YYYY"
                placeholder="اختر تاريخ الاستلام"
                v-model.trim="field.received_date.$model"
                :class="{ 'is-invalid': field.received_date.$error }"
              ></date-picker>
              <div v-if="field.received_date.$error" class="invalid-feedback">
                <span v-if="!field.received_date.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label=" المبلغ المستلم : "
              label-for="ammont"
            >
              <b-form-input
                id="ammont"
                type="number"
                placeholder="ادخل المبلغ المستلم"
                v-model.trim="field.ammont.$model"
                :class="{ 'is-invalid': field.ammont.$error }"
              ></b-form-input>
              <div v-if="field.ammont.$error" class="invalid-feedback">
                <span v-if="!field.ammont.required">هذا الحقل الزامي </span>
                <span v-if="!field.ammont.minValue"
                  >يجب أن يكون المبلغ المستلم 1000 على الأقل</span
                >
                <span v-if="!field.ammont.maxValue"
                  >يجب أن يكون المبلغ المستلم 80000000 على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label=" اسم مستلم القطعة : "
              label-for="beneficiary_id"
            >
              <select
                class="form-control"
                id="beneficiary_id"
                v-model.trim="field.beneficiary_id.$model"
                :class="{ 'is-invalid': field.beneficiary_id.$error }"
              >
                <option value="">اختر المستفيد</option>
                <option
                  v-for="beneficiary in getBeneficiaries()"
                  :value="beneficiary.id"
                  :key="beneficiary.id"
                >
                  {{ beneficiary.name }}
                </option>
              </select>
              <div v-if="field.beneficiary_id.$error" class="invalid-feedback">
                <span v-if="!field.beneficiary_id.required">هذا الحقل الزامي </span>
              </div>
            </b-form-group>
          </div>
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">مرفق البدل النقدي</h5></div>
          <ul class="li-attachments">
            <li>مرفق يثبت استلام البدل النقدي للارض .</li>
            <li>
              يجب ارفاق مستند يثبت استلام البدل النقدي بملف واحد بصيغة ( pdf. ) وبحجم لا
              يتجاوز ( 2mb ) .
            </li>
          </ul>
          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              label=" مرفق يثبت استلام البدل النقدي :"
              :label-for="'attachment_cash' + index"
            >
              <div class="custom_file">
                <b-form-file
                  :id="'attachment_cash' + index"
                  class=""
                  :data-index="index"
                  placeholder="اختر المرفق"
                  accept=".pdf"
                  v-model.trim="field.attachment_cash.$model"
                  @change="chnageFile"
                  :class="{ 'is-invalid': field.attachment_cash.$error }"
                ></b-form-file>
                <div v-if="field.attachment_cash.$error" class="invalid-feedback">
                  <span v-if="!field.attachment_cash.required">هذا الحقل الزامي</span>
                  <span v-if="!field.attachment_cash.fileSize"
                    >يجب ان لا يتجاوز حجم الملف 2mb</span
                  >
                  <span v-if="!field.attachment_cash.fileType"
                    >يجب ان يكون نوع الملف pdf</span
                  >
                </div>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>
            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
          <input
            type="button"
            class="btn btn-primary mt-3 mb-3 mt-lg-0"
            style="width: 100%"
            value="اضافة بدل نقدي اخر"
            @click="AddformDataS"
          />
        </div>
      </form>
    </div>
  </div>

  <!-- end page title -->
</template>
